<template>
  <div class="org-manage">
    <loading :isShow="loading" />
    <orgTree ref="tree" source="1" @change="treeChange" :style="{ 'width': leftWidth - 15 + 'px' }"></orgTree>
    <move-line @move="leftWidth = $event" :style="{ 'left': leftWidth - 5 + 'px' }"></move-line>
    <div class="right-panel" :style="{ 'width': 'calc(100vw - ' + (leftWidth - 15) + ')px' }">
      <div class="info-box">
        <div :class="curTreeData.status == 2 ? 'dian red' : 'dian green'"></div>
        <div class="text1">{{ curTreeData.name }}</div>
        <template v-if="!curTreeData.isTop">
          <div class="tag" v-if="curTreeData.orgType == 1">总部</div>
          <div class="tag" v-if="curTreeData.orgType == 2">省分</div>
          <div class="tag" v-if="curTreeData.orgType == 3">市级</div>
          <div class="tag" v-if="curTreeData.orgType == 4">区级</div>
          <div class="tag" v-if="curTreeData.orgType == 5">渠道</div>
          <div class="tag" v-if="curTreeData.orgType == 6">营业部</div>
        </template>
        <template v-if="[1, 2, 3, 4].includes(curTreeData.orgType * 1) || userInfo.organId == curTreeData.id">
          <div class="text2">总下属机构</div>
          <div class="text3">{{ count.subCompanyCount }}</div>
          <div class="text2 two">总下属团队</div>
          <div class="text3">{{ count.subGroupCount }}</div>
          <div class="text2 two">总下属业务员</div>
          <div class="text3">{{ count.subAgencyCount }}</div>
        </template>
      </div>

      <div class="tools-box left" :class="{'edit':isEdit}">
        <Button type="primary" v-if="$units.pointAction('org_1_1') && btnAuth.includes('1')" @click="$refs.addOrg.open({...curTreeData,ico:detail.ico})">新增机构</Button>
        <!-- <Button type="warning" v-else-if="$units.pointAction('org_1_3') && btnAuth.includes('2')" @click="$refs.addOrg.open(curTreeData,'outside')">新增渠道</Button> -->
        <Button type="success" v-if="$units.pointAction('org_1_3') && btnAuth.includes('3')" @click="$refs.addTeam.open(curTreeData, detail)">{{curTreeData.nodeType == 2 && curTreeData.levelCode != 20005?'新增子团队':'新增团队'}}</Button>
        <Button type="success" v-if="$units.pointAction('org_1_7') && curTreeData.nodeType == 2" @click="$refs.removeTeam.open(curTreeData, detail)">团队迁移</Button>
        <!-- 这版不做 -->
        <!-- <Button type="success" @click="$refs.removeTeam.open(curTreeData, detail)">团队迁移</Button> -->
        <!-- 商户 且 开启保交所配置 且 全国持牌 -->
        <Button type="warning" @click="syncBJS()" v-if="curTreeData.orgType == 1 && userInfo.licenseType == 1 && userInfo.bjsSync == 1">同步保交所</Button>
        <Button type="error" @click="del()" v-if="$units.pointAction('org_1_6') && curTreeData.isTop!=1">删除</Button>
      </div>
      <!-- 不存在tab且不存在新增按钮使用out,不存在tab存在按钮使用team -->
      <div class="tab-box" :class="{
        out: (curTreeData.orgType == 5 && !curTreeData.isTop) || (!btnAuth.includes('3') && !curTreeData.orgType),
        team: !curTreeData.orgType && btnAuth.includes('3')
      }">
        <!-- 团队或下级渠道不显示 -->
        <Tabs v-model="tabId" :animated="false" @on-click="tabChange"
          v-if="curTreeData.isTop || (curTreeData.orgType && curTreeData.orgType != 5)">
          <TabPane v-for="(bean) in tabList" :key="bean.id" :label="bean.name" :name="bean.id" v-if="bean.show">
          </TabPane>
        </Tabs>
        <component :is="tabId + 'Form'" :ref="tabId" :formData="detail" :curTreeData="curTreeData"
          @success="$refs.tree.getTreeData($event);" @isEdit="isEdit = $event"></component>
      </div>
    </div>

    <!-- 新增机构 -->
    <add-org ref="addOrg" @success="$refs.tree.getTreeData($event)"></add-org>
    <!-- 新增团队 -->
    <add-team ref="addTeam" @success="$refs.tree.getTreeData($event)"></add-team>
    <!-- 团队迁移 -->
    <removeTeam ref="removeTeam" @success="$refs.tree.getTreeData(curTreeData.id)"></removeTeam>
  </div>
</template>

<script>
import addOrg from './components/addOrg'
import baseForm from './components/base'
import addTeam from './components/addTeam'
import materialForm from './components/material'
import removeTeam from './components/removeTeam'
import baseTeamForm from './components/baseTeam'
import promotionForm from './components/promotion'
import moveLine from "@/components/commons/moveLine";
import orgTree from "@/components/commons/orgTree/orgTree";
export default {
  mixins: [],
  components: {
    orgTree,
    baseForm,
    baseTeamForm,
    promotionForm,
    materialForm,
    addOrg,
    addTeam,
    moveLine,
    removeTeam
  },
  props: {},
  data() {
    return {
      leftWidth: 270,
      loading: false,
      isEdit: false,//是否在编辑
      tabId: "base",
      tabList: [
        { id: "base", name: "基础信息", form: "baseForm", show: true },
        { id: "promotion", name: "基本法信息", form: "promotionForm", show: true },
        { id: "material", name: "资料信息", form: "materialForm", show: true },
      ],
      curTreeData: {},
      count: {},
      detail: {},
      userInfo: {},
      btnAuth: "",//按钮权限
    };
  },
  computed: {},
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    // 同步保交所
    syncBJS() {
      if(this.loading) {
        return;
      }
      this.loading = true;
      this.$http({
        url: '/buz/organizationBase/batchSyncBjsOrg',
        type: 'get',
        data: {
          id: this.curTreeData.id
        },
      }).then((res) => {
        this.$notice.success('同步成功');
        this.getDetailData();
      }).finally(() => {
        window.setTimeout(() => {
          this.loading = false;
        }, 500)
      })
    },
    tabChange() {
      // console.log("tabChange")
      this.$nextTick(() => {
        this.$refs[this.tabId].setData(this.detail)
      })
    },
    async treeChange(data) {
      // console.log("treeChange",data)
      this.curTreeData = JSON.parse(JSON.stringify(data));
      console.log(this.curTreeData)
      // 机构有基本法tab，渠道没有，二、三级机构基本法不支持修改
      this.tabList[1].show = this.curTreeData.orgType ? true : false
      // const promotionPage = this.tabList.find(item=>{
      //   return item.id == 'promotion'
      // })
      // if(this.userInfo.isThird){//本级或者祖先是渠道
      //   promotionPage.show = false;
      // }else{
      //   promotionPage.show = true;
      // }

      this.loading = true;
      Promise.all([
        this.getDetailData(),
        this.getBtnStatus(),
        this.getCountData(),
      ]).then(e => {

      }).finally(e => {
        this.loading = false;
      })
    },
    getBtnStatus() {
      const data = this.curTreeData;
      if (data.nodeType == 1) {//机构
        this.btnAuth = "";
        return this.$http({
          url: '/buz/organizationBase/canAdd',
          type: 'get',
          data: {
            orgId: data.id,
          },
        }).then((res) => {
          const data = res.data;
          if (data.hasAdd) {
            this.btnAuth = data.addType;
          } else {
            this.btnAuth = "";
          }
        })
      } else if (data.nodeType == 2 && data.levelCode != 20005) {//团队
        this.btnAuth = "3";
      } else {
        this.btnAuth = "";
      }
    },
    // 获取统计数据
    getCountData() {
      const data = this.curTreeData;
      return this.$http({
        url: data.nodeType == 1 ? '/buz/organizationBase/statistics' : '/buz/organizationGroup/statistics',
        type: data.nodeType == 1 ? 'POST' : 'GET',
        data: data.nodeType == 1 ? {
          id: data.id,
          selectSub: '1'
        } : {
          groupId: data.id,
        },
      }).then((res) => {
        this.count = res.data;
      })
    },
    getDetailData() {
      const data = this.curTreeData;
      return this.$http({
        url: data.nodeType == 1 ? '/buz/organizationBase/read/detail' : '/buz/organizationGroup/read/detail',
        type: 'get',
        data: {
          id: data.id,
        },
        apiPermissionCode:'org_1_0'
      }).then((res) => {
        this.detail = res.data;
        this.detail.supervise = res.data.supervise?res.data.supervise:'1';
        if (data.orgType) {//机构
          this.tabId = "base";
        } else {//团队
          this.tabId = "baseTeam";
        }
        this.tabChange();
      })
    },
    del() {
      this.$notice.inquiry("确定删除吗？").then(() => {
        this.$http({
          url: this.curTreeData.orgType ? "/buz/organizationBase/logic/del" : "/buz/organizationGroup/logic/del",
          type: "get",
          data: {
            id:this.curTreeData.id,
          },
          apiPermissionCode:'org_1_6'
        }).then(res=>{
          this.$notice.success("删除成功");
          this.$refs.tree.getTreeData();
          localStorage.setItem('updataOrgAndTeam', 1);
        })
      });
    }
  },
};
</script>
<style lang="scss" scoped>
@import './orgManage.scss';
</style>